import { GenderEnum } from "./gender-enum";

export const genderLabels = {
  [GenderEnum.MAN]: "Pria",
  [GenderEnum.WOMAN]: "Wanita",
};
